import { render, staticRenderFns } from "./systemTab.vue?vue&type=template&id=877c9f24&scoped=true&"
import script from "./systemTab.vue?vue&type=script&lang=js&"
export * from "./systemTab.vue?vue&type=script&lang=js&"
import style0 from "./systemTab.vue?vue&type=style&index=0&id=877c9f24&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877c9f24",
  null
  
)

export default component.exports